import { AppContext, useApp } from '@/hooks/useApp'
import {
  V1IconType,
  V1NavigateActionType,
  V1RouteType,
  V1ScreenType
} from 'mnvm-mypage-app-ts-if'
import NavigationListSP from './NavigationListSP/NavigationListSP'
import styled from 'styled-components'
import { useNavigator } from '@/hooks/useNavigator'
import { useContext } from 'react'
import { type Navigation } from './Header'

const NavigationSPWrapper = styled.div`
  background-color: white;
  z-index: 11;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  flex: none;
  width: auto;
`

export interface SPSideMenuProps {
  onClickCloseNavigationList: () => void
}

export const SPSideMenu = ({
  onClickCloseNavigationList
}: SPSideMenuProps): JSX.Element => {
  const app = useApp()
  const nav = useNavigator()

  const { dispatch } = useContext(AppContext)

  const navigationListSP =
    app.hamburgerMenu.items?.map((item): Navigation => {
      return {
        name: item.text ?? '',
        icon: item.iconType ?? V1IconType.Unspecified,
        onClick: () => {
          if (
            item.navigateActionType === V1NavigateActionType.GotoSpecificRoute
          ) {
            if (V1RouteType.FavoriteJobPostings === item.routeType) {
              if (item.iconType === V1IconType.History) {
                void nav?.gotoFavoriteJobposting(1)
                dispatch({
                  ...app,
                  screenType: V1ScreenType.JobPostingBrowsingHistory
                })
              } else {
                void nav?.gotoFavoriteJobposting(0)
                dispatch({
                  ...app,
                  screenType: V1ScreenType.FavoriteJobPostings
                })
              }

              return
            }
            if (V1RouteType.JobPostingJobSeekerAction === item.routeType) {
              void nav?.gotoFavoriteJobposting(2)
              dispatch({
                ...app,
                screenType: V1ScreenType.JobPostingInquired
              })
              return
            }

            if (V1RouteType.Url === item.routeType) {
              window.open(item.url ?? '', '_blank')
              return
            }

            void nav?.goToRouteByRouteType(item.routeType)
          }
        }
      }
    }) ?? []

  return (
    <NavigationSPWrapper>
      <NavigationListSP
        navigationList={navigationListSP}
        onClickCloseIcon={() => {
          onClickCloseNavigationList()
        }}
      />
    </NavigationSPWrapper>
  )
}
